module.exports = __webpack_public_path__ + "img/PO.46053bd2.svg";